var $b9eba5a31eae3293$exports = {};
//Navigation working
//data
const $b9eba5a31eae3293$var$burger = document.querySelector(".c-header__hamburger");
const $b9eba5a31eae3293$var$navigation = document.querySelector(".nav");
const $b9eba5a31eae3293$var$liServices = document.querySelector('[data-index="services"]');
const $b9eba5a31eae3293$var$liContact = document.querySelector('[data-index="contact"]');
const $b9eba5a31eae3293$var$services = document.querySelector(".nav__services");
const $b9eba5a31eae3293$var$wrapperLeft = document.querySelector(".nav__wrapper__left");
const $b9eba5a31eae3293$var$contact = document.querySelector(".s-contact__header");
const $b9eba5a31eae3293$var$contactHeader = document.querySelector(".c-header__contact");
const $b9eba5a31eae3293$var$navigationList = document.querySelectorAll(".nav__wrapper__left li");
const $b9eba5a31eae3293$var$navFooter = document.querySelector(".nav__footer");
const $b9eba5a31eae3293$var$main = document.querySelector("main");
const $b9eba5a31eae3293$var$headingWrapper = document.querySelector(".c-header__container ");
const $b9eba5a31eae3293$var$openMenuContact = document.querySelectorAll(".open-menu-contact");
const $b9eba5a31eae3293$var$openBottomContact = document.querySelectorAll(".open-bottom-contact");
const $b9eba5a31eae3293$var$burgerAn = $b9eba5a31eae3293$var$burger.firstChild.nextSibling;
const $b9eba5a31eae3293$var$socials = document.querySelector(".nav__footer__socials");
const $b9eba5a31eae3293$var$contactForm = document.querySelector("#contact");
const $b9eba5a31eae3293$var$allHeader = document.querySelector(".c-header");
const $b9eba5a31eae3293$var$hamburgerMenu = document.querySelector(".c-header__hamburger__lines");
const $b9eba5a31eae3293$var$logo = document.querySelector(".c-main-logo");
const $b9eba5a31eae3293$var$lastSocials = document.querySelector("#last-nav-socials");
$b9eba5a31eae3293$var$allHeader.classList.add("c-header--open");
const $b9eba5a31eae3293$var$body = document.querySelector("body");
//Hidden navbar opition during scroll
document.addEventListener("scroll", ()=>{
    if (document.documentElement.scrollTop > 10) {
        for (const child of $b9eba5a31eae3293$var$contactHeader.childNodes)if (child.classList && !child.classList.contains("c-header__contact--cta")) child.classList.add("hidden");
        $b9eba5a31eae3293$var$allHeader.classList.add("headerBackground");
    } else {
        for (const child of $b9eba5a31eae3293$var$contactHeader.childNodes)if (child.classList && !child.classList.contains("c-header__contact--cta")) child.classList.remove("hidden");
        $b9eba5a31eae3293$var$allHeader.classList.remove("headerBackground");
    }
});
//'contact us' btn whitch open contact form menu
$b9eba5a31eae3293$var$openMenuContact.forEach((element)=>{
    element.addEventListener("click", ()=>{
        $b9eba5a31eae3293$var$contactHeader.classList.add("hidden");
        $b9eba5a31eae3293$var$allHeader.style.transform = "translateY(0)";
        $b9eba5a31eae3293$var$burgerAn.classList.add("c-header__hamburger__lines--open");
        $b9eba5a31eae3293$var$body.classList.add("overflow");
        setTimeout(()=>{
            $b9eba5a31eae3293$var$navigation.classList.add("nav__open");
            $b9eba5a31eae3293$var$openContact();
        }, 500);
    });
});
//open bottom contact
$b9eba5a31eae3293$var$openBottomContact.forEach((element)=>{
    element.addEventListener("click", ()=>{
        const contact = document.querySelector("#before-contact");
        window.scrollTo(0, contact.offsetTop, 600);
    });
});
// close menu on click next to menu
document.querySelector("main").addEventListener("click", ()=>{
    if ($b9eba5a31eae3293$var$navigation.classList.contains("nav__open")) $b9eba5a31eae3293$var$closeMenu();
});
//open menu
$b9eba5a31eae3293$var$burger.addEventListener("click", ()=>{
    //close by arrow
    if ($b9eba5a31eae3293$var$navigation.classList.contains("nav__open")) $b9eba5a31eae3293$var$closeMenu();
    else {
        //open by hamburger
        document.removeEventListener("scroll", $b9eba5a31eae3293$var$scrollHeader);
        $b9eba5a31eae3293$var$body.classList.add("overflow");
        $b9eba5a31eae3293$var$navigation.classList.toggle("nav__open");
        $b9eba5a31eae3293$var$burgerAn.classList.add("c-header__hamburger__lines--open");
        $b9eba5a31eae3293$var$contactHeader.classList.add("hidden");
        $b9eba5a31eae3293$var$hamburgerMenu.classList.remove("background-black");
        $b9eba5a31eae3293$var$burgerAn.classList.remove("background-black");
        $b9eba5a31eae3293$var$logo.classList.remove("c-main-logo--dark");
        if ($b9eba5a31eae3293$var$allHeader.classList.contains('header--dark') && document.documentElement.scrollTop <= 10) $b9eba5a31eae3293$var$logo.classList.add('c-main-logo--dark');
    }
});
//click services
$b9eba5a31eae3293$var$liServices.addEventListener("click", $b9eba5a31eae3293$var$openServices);
//click contact
$b9eba5a31eae3293$var$liContact.addEventListener("click", $b9eba5a31eae3293$var$openContact);
//Open Menu Services
function $b9eba5a31eae3293$var$openServices() {
    $b9eba5a31eae3293$var$services.classList.add("visible");
    $b9eba5a31eae3293$var$outlineElements();
    $b9eba5a31eae3293$var$lastSocials.classList.add("nav__footer__socials--active");
    $b9eba5a31eae3293$var$liServices.parentElement.classList.remove("st-outline");
    $b9eba5a31eae3293$var$liServices.classList.add("st-boldArrow--focus");
    $b9eba5a31eae3293$var$liContact.classList.remove("st-boldArrow--focus");
    $b9eba5a31eae3293$var$services.classList.add("opacity");
    $b9eba5a31eae3293$var$navigation.classList.add("nav__full");
    $b9eba5a31eae3293$var$socials.classList.add("nav__footer__socials--active");
    $b9eba5a31eae3293$var$contact.classList.remove("visible");
    $b9eba5a31eae3293$var$contact.classList.remove("opacity");
    setTimeout(()=>{
        $b9eba5a31eae3293$var$services.classList.add("transformation-mobile");
    }, 100);
}
function $b9eba5a31eae3293$var$openContact() {
    $b9eba5a31eae3293$var$contact.classList.add("visible");
    $b9eba5a31eae3293$var$outlineElements();
    $b9eba5a31eae3293$var$navFooter.classList.add("nav__footer--active");
    $b9eba5a31eae3293$var$liContact.parentElement.classList.remove("st-outline");
    $b9eba5a31eae3293$var$liContact.classList.add("st-boldArrow--focus");
    $b9eba5a31eae3293$var$liServices.classList.remove("st-boldArrow--focus");
    $b9eba5a31eae3293$var$contact.classList.add("opacity");
    $b9eba5a31eae3293$var$lastSocials.classList.add("nav__footer__socials--active");
    $b9eba5a31eae3293$var$navigation.classList.add("nav__full");
    $b9eba5a31eae3293$var$socials.classList.add("nav__footer__socials--active");
    $b9eba5a31eae3293$var$services.classList.remove("visible");
    $b9eba5a31eae3293$var$services.classList.remove("opacity");
    setTimeout(()=>{
        $b9eba5a31eae3293$var$contact.classList.add("transformation-mobile");
    }, 100);
}
//outline for all liElements
function $b9eba5a31eae3293$var$outlineElements() {
    $b9eba5a31eae3293$var$navigationList.forEach((el)=>{
        el.classList.add("st-outline");
    // el.firstChild.classList.remove('st-boldArrow--focus')
    });
}
//removing outline
function $b9eba5a31eae3293$var$outlineElementsReverse() {
    $b9eba5a31eae3293$var$navigationList.forEach((el)=>{
        el.classList.remove("st-outline");
    });
}
//hamburger animation
$b9eba5a31eae3293$var$burger.addEventListener("mouseover", ()=>{
    if (!$b9eba5a31eae3293$var$burgerAn.classList.contains("c-header__hamburger__lines--open")) $b9eba5a31eae3293$var$burgerAn.classList.add("c-header__hamburger__lines--active");
    else $b9eba5a31eae3293$var$burgerAn.classList.add("c-header__hamburger__lines--open--hover");
});
$b9eba5a31eae3293$var$burger.addEventListener("mouseout", ()=>{
    if (!$b9eba5a31eae3293$var$burgerAn.classList.contains("c-header__hamburger__lines--open")) $b9eba5a31eae3293$var$burgerAn.classList.remove("c-header__hamburger__lines--active");
    else $b9eba5a31eae3293$var$burgerAn.classList.remove("c-header__hamburger__lines--open--hover");
});
//close Menu
function $b9eba5a31eae3293$var$closeMenu() {
    $b9eba5a31eae3293$var$burgerAn.classList.remove("c-header__hamburger__lines--open");
    $b9eba5a31eae3293$var$burgerAn.classList.remove("c-header__hamburger__lines--open--hover");
    $b9eba5a31eae3293$var$socials.classList.remove("nav__footer__socials--active");
    $b9eba5a31eae3293$var$liServices.classList.remove("st-boldArrow--focus");
    $b9eba5a31eae3293$var$liContact.classList.remove("st-boldArrow--focus");
    $b9eba5a31eae3293$var$navFooter.classList.remove("nav__footer--active");
    $b9eba5a31eae3293$var$headingWrapper.classList.remove("c-header__container--active");
    $b9eba5a31eae3293$var$navigation.classList.toggle("nav__open");
    $b9eba5a31eae3293$var$navigation.classList.remove("nav__full");
    $b9eba5a31eae3293$var$contact.classList.remove("nav__full");
    $b9eba5a31eae3293$var$services.classList.remove("visible");
    $b9eba5a31eae3293$var$contact.classList.remove("visible");
    $b9eba5a31eae3293$var$services.classList.remove("transformation-mobile");
    $b9eba5a31eae3293$var$contact.classList.remove("transformation-mobile");
    $b9eba5a31eae3293$var$lastSocials.classList.remove("nav__footer__socials--active");
    $b9eba5a31eae3293$var$body.classList.remove("overflow");
    // closeForm();
    $b9eba5a31eae3293$var$outlineElementsReverse();
    document.addEventListener("scroll", $b9eba5a31eae3293$var$scrollHeader);
    setTimeout(()=>{
        $b9eba5a31eae3293$var$contactHeader.classList.remove("hidden");
    }, 400);
    /*if (!allHeader.classList.contains("headerBackground")) {
    contactHeader.classList.remove("hidden");
  }*/ if (window.scrollTop == 0 & $b9eba5a31eae3293$var$main.classList.contains("case-study")) {
        $b9eba5a31eae3293$var$burgerAn.classList.add("background-black");
        $b9eba5a31eae3293$var$logo.classList.add("c-main-logo--dark");
    }
    if ($b9eba5a31eae3293$var$allHeader.classList.contains('header--dark') && document.documentElement.scrollTop <= 10) {
        $b9eba5a31eae3293$var$logo.classList.add('c-main-logo--dark');
        $b9eba5a31eae3293$var$hamburgerMenu.classList.add('background-black');
    }
}
const $b9eba5a31eae3293$var$startBtn = document.querySelector(".buttonParallax");
const $b9eba5a31eae3293$var$projectInfo = document.querySelector(".s-project__info");
let $b9eba5a31eae3293$var$oldValue = 0;
let $b9eba5a31eae3293$var$newValue = 0;
let $b9eba5a31eae3293$var$direction = 0;
let $b9eba5a31eae3293$var$flag = 0;
/* Always keep the header visible
 document.addEventListener("scroll", scrollHeader);*/ function $b9eba5a31eae3293$var$scrollHeader() {
    $b9eba5a31eae3293$var$newValue = document.documentElement.scrollTop;
    if ($b9eba5a31eae3293$var$oldValue < $b9eba5a31eae3293$var$newValue && $b9eba5a31eae3293$var$oldValue > 0) {
        if ($b9eba5a31eae3293$var$flag === 0) {
            $b9eba5a31eae3293$var$flag = 1;
            $b9eba5a31eae3293$var$allHeader.classList.remove("headerBackground");
            /* Always keep the header visible
      allHeader.style.transform = "translateY(-100%)";*/ setTimeout(()=>{}, 4000);
            return;
        }
    } else if ($b9eba5a31eae3293$var$oldValue > $b9eba5a31eae3293$var$newValue) {
        if ($b9eba5a31eae3293$var$flag === 1) {
            $b9eba5a31eae3293$var$flag = 0;
            $b9eba5a31eae3293$var$allHeader.classList.add("headerBackground");
            $b9eba5a31eae3293$var$allHeader.style.transform = "translateY(0)";
            return;
        }
    }
    $b9eba5a31eae3293$var$oldValue = $b9eba5a31eae3293$var$newValue;
    return;
}


//# sourceMappingURL=flipside-www-2022.4d7bb2a0.js.map
